<script>
	import {fade} from "svelte/transition";
	export let smile = 30;

	if (smile > 100){
		smile = 100;
	}
	if (smile<0) {
		smile = 0;
	}
	export let stroke="#000000"
	export let fill="#ffffff"
	export let scale = "1";
	export let size = "30";
</script>

<svg
		 style="transform-origin:center;transform:scale({scale});"
		 width="{size}"
		 height="{size}"
		 viewBox="0 0 30 30"
		 fill="none"
		 xmlns="http://www.w3.org/2000/svg"
		 >
	<circle cx="15" cy="15" r="13.5" fill={fill} stroke={stroke} stroke-width="3"/>

	{#if smile>90}
	<path  d="M23.5716 9.64771C22.7929 9.24105 21.7506 9.45703 21.2221 9.61131C21.0467 9.08943 20.6284 8.11067 19.8497 7.70401C18.5181 7.00863 17.326 7.35059 16.6632 8.61981C16.1201 9.65984 16.6456 11.041 16.6651 11.0894L18.0548 15.1116C18.1203 15.3007 18.3256 15.408 18.5182 15.3536L22.6042 14.202C22.664 14.184 24.0985 13.8246 24.6409 12.786C25.3037 11.5168 24.9032 10.3431 23.5716 9.64771Z" fill={stroke}/>
	<path  d="M5.87787 9.64771C6.65657 9.24105 7.69884 9.45703 8.22735 9.61131C8.40275 9.08943 8.8211 8.11067 9.5998 7.70401C10.9314 7.00863 12.1234 7.35059 12.7862 8.61981C13.3294 9.65984 12.8039 11.041 12.7844 11.0894L11.3947 15.1116C11.3292 15.3007 11.1239 15.408 10.9312 15.3536L6.84523 14.202C6.78543 14.184 5.35097 13.8246 4.80859 12.786C4.14576 11.5168 4.5463 10.3431 5.87787 9.64771Z" fill={stroke}/>


	{:else if smile <10}
	<path  d="M23.937 12.1713C24.5839 11.6538 24.6888 10.7099 24.1713 10.063C23.6538 9.41607 22.7098 9.31118 22.063 9.8287C21.0619 10.6295 20.081 10.9176 19.3643 11.0132C19.0029 11.0613 18.7085 11.0604 18.5153 11.0493C18.419 11.0438 18.3493 11.0359 18.3105 11.0307C18.2934 11.0285 18.2825 11.0267 18.2782 11.026C17.4715 10.8736 16.6905 11.3988 16.5291 12.2058C16.3667 13.0182 16.8935 13.8084 17.7058 13.9709L18 12.5C17.7058 13.9709 17.7072 13.9712 17.7072 13.9712L17.7087 13.9714L17.7118 13.9721L17.7188 13.9734L17.7356 13.9766C17.7481 13.9789 17.7631 13.9815 17.7805 13.9845C17.8154 13.9903 17.8601 13.9972 17.9141 14.0044C17.9525 14.0095 17.9956 14.0148 18.0433 14.0199C18.2347 15.1511 19.0381 16 20 16C21.1046 16 22 14.8807 22 13.5C22 13.4513 21.9989 13.4029 21.9967 13.3549C22.6263 13.0768 23.2836 12.6941 23.937 12.1713Z" fill={stroke}/>
	<path d="M6.06295 12.1713C5.41606 11.6538 5.31118 10.7099 5.82869 10.063C6.34621 9.41607 7.29014 9.31118 7.93704 9.8287C8.9381 10.6295 9.91902 10.9176 10.6357 11.0132C10.9971 11.0613 11.2915 11.0604 11.4847 11.0493C11.581 11.0438 11.6507 11.0359 11.6894 11.0307C11.7066 11.0285 11.7175 11.0267 11.7218 11.026C12.5285 10.8736 13.3095 11.3988 13.4709 12.2058C13.6333 13.0182 13.1065 13.8084 12.2942 13.9709L12 12.5C12.2942 13.9709 12.2928 13.9712 12.2928 13.9712L12.2913 13.9714L12.2882 13.9721L12.2812 13.9734L12.2644 13.9766C12.2519 13.9789 12.2369 13.9815 12.2195 13.9845C12.1846 13.9903 12.1399 13.9972 12.0859 14.0044C12.0475 14.0095 12.0044 14.0148 11.9567 14.0199C11.7653 15.1511 10.9619 16 9.99999 16C8.89542 16 7.99999 14.8807 7.99999 13.5C7.99999 13.4513 8.00111 13.4029 8.00331 13.3549C7.37374 13.0768 6.71643 12.6941 6.06295 12.1713Z" fill={stroke}/>

	{:else}
	<ellipse cx="20" cy="12" rx="2" ry="2.5" fill={stroke}/>
	<ellipse cx="10" cy="12" rx="2" ry="2.5" fill={stroke}/>
		{/if}
	<path d="M10,20 Q15,{15+(smile/10)} 20,20" stroke={stroke} stroke-width="3" stroke-linecap="round"></path>
</svg>

